
import { Component, Vue } from 'vue-property-decorator'
import DatePicker from '@/components/date-picker.vue'
import { apiEarnestLists, apiPutEarnest } from '@/api/earnest'
import { RequestPaging } from '@/utils/util'
import LsPagination from '@/components/ls-pagination.vue'
import LsDialog from '@/components/ls-dialog.vue'
@Component({
    components: {
        DatePicker,
        LsPagination,
        LsDialog
    }
})
export default class Earnest extends Vue {
    $refs!: { dialog: any; dialog3: any }
    // S Data
    activeName: any = 'all' //全部;
    value: any = [1]
    pager = new RequestPaging()
    apiEarnestLists = apiEarnestLists
    tabCount = {
        all: 0, //全部
        wait: 0, //待支付
        finish: 0 //已关闭
    }
    form: any = {
        name: '',
        contact: '',
        contact_mobile: ''
    }
    data: any = []
    depositData: any = {
        sid: '',
        type: 1,
        deposit: ''
    }
    sendDeposit: any = ''
    recycleDeposit: any = ''
    // E Data

    // S Methods
    reset() {
        this.form = {
            name: '',
            contact: '',
            contact_mobile: ''
        }

        this.getEarnestLists()
    }
    getEarnestLists() {
        this.pager.request({
            callback: apiEarnestLists,
            params: {
                ...this.form
            }
        })
    }
    sendEarnest() {
        if (this.depositData.deposit === '') {
            this.$message({
                message: '请输入大于0的数字',
                type: 'error'
            })
            return
        }
        apiPutEarnest(this.depositData).then(res => {
            this.$message({
                message: this.depositData.type === 1 ? '发放成功' : '回收成功',
                type: 'success'
            })
            this.getEarnestLists()
            this.$refs.dialog.close()
        })
    }

    handleInput(value: any) {
        if (!Number.isInteger(Number(value)) || value <= 0) {
            this.$message({
                message: '请输入大于0的数字',
                type: 'warning'
            })
            this.depositData.deposit = ''
        }
    }
    close() {
        this.depositData = {
            sid: '',
            type: 1,
            deposit: ''
        }
    }
    // E Methods

    // S  life cycle

    created() {
        this.getEarnestLists()
    }

    // E life cycle
}
